module.exports = __webpack_public_path__ + "img/banner6.e477ea18.png";